import { useMemo } from 'react';
import { Stack, Typography, Box, useTheme } from '@mui/material';
import buildFilterString from '../../helpers/buildFilterString';
import { VigoTypography } from 'src/@vigo/vigo-typography';
import { useSettings } from 'src/@core/hooks/useSettings';
import router from 'next/router';
import { useVigoTranslation } from 'src/@core/hooks/useVigoTranslation';
import { useGetDashboardMetricsQuery } from 'src/queries/services/salesorder';

const TotalOrders = ({ dashboardDateStrings = [[''], ['']], orderByValue = '' }) => {
  const theme = useTheme();
  const settings = useSettings();

  const { t } = useVigoTranslation();

  const queryParamFilter = useMemo(() => {
    return buildFilterString(orderByValue, dashboardDateStrings);
  }, [orderByValue, dashboardDateStrings]);

  const { data: dashboardMetrics } = useGetDashboardMetricsQuery({ params: { filter: queryParamFilter } });

  const total = String(dashboardMetrics?.total ?? 0);

  function onCLick() {
    if (!settings.settings.unlockDashboardLayout) {
      router.push(
        `/uiflow/consignment?filter=${buildFilterString(
          orderByValue,
          dashboardDateStrings
        )}&extrafilter=isDeleted eq false`
      );
    }
  }

  return (
    <Stack
      direction="column"
      onClick={onCLick}
      sx={{
        height: '100%',
        backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#1e1e1e',
        borderRadius: '5px',
        cursor: 'pointer'
      }}>
      <Box>
        <Typography
          onClick={onCLick}
          sx={{
            marginTop: '10px',
            marginLeft: '10px',
            textAlign: 'left',
            fontSize: 'clamp(1rem, 10cqw, 1.5rem)',
            fontWeight: '600',
            cursor: 'pointer'
          }}>
          {t('Total Consignments')}
        </Typography>
      </Box>
      <VigoTypography
        value={total}
        onClick={onCLick}
        className="countWidget__count"
        sx={{
          fontSize: 'clamp(1rem, 30cqw, 3.714rem) !important',
          fontWeight: '500',
          cursor: 'pointer'
        }}
        disableTranslation
      />
    </Stack>
  );
};

export default TotalOrders;
